import { SECTION } from './constants';

export const buildEventData = ({
  event,
  category = SECTION,
  subcategory,
  action,
  where,
  label,
  ...options
}) => ({
  event,
  event_category: `${category}${subcategory ? `:${subcategory}` : ''}`,
  event_action: `${action}:${where || label}`,
  event_label: label,
  ...options
});
